import React from "react";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import { SingleDatePicker } from "react-dates";

class DateSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
    };
  }

  focusChange = (state) => {
    this.setState(state);
  };

  render() {
    const { date, updateDate } = this.props;
    return (
      <SingleDatePicker
        date={date ? moment(date) : null}
        onDateChange={updateDate}
        focused={this.state.focused}
        onFocusChange={this.focusChange}
        isOutsideRange={(day) => day.isAfter(moment())}
        numberOfMonths={1}
        anchorDirection="right"
        appendToBody
        small
        showDefaultInputIcon
        hideKeyboardShortcutsPanel
        placeholder="Filter by Recent Activity"
        showClearDate
      />
    );
  }
}

export default DateSelect;
